import { render } from "./ClubMembers.vue?vue&type=template&id=190308c5&ts=true"
import script from "./ClubMembers.vue?vue&type=script&lang=ts"
export * from "./ClubMembers.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__